import React from "react"
import ModalCustom from "../ModalCustom"
import alertSvg from "../../images/alert.svg"
import { TYPE_QUESTION } from "../../utils/constants"

const ModalDeleteQuestion = (props) => {
  const onOk = () => {
    const params = {
      idQuestion: props.question.id_question,
      idSurvey: props.survey.id || props.survey.id_survey,
    }

    props.deleteQuestion(params)
  }

  const onCancel = () => {
    props.cancelDeleteQuestion()
  }

  const hasMeasureCustomMessage = () => {

    if(props.question) {
      if(props.question.id_question_type != TYPE_QUESTION.multiple_choice){
        return (props.question.id_question_type == TYPE_QUESTION.qualitative) ? 'Perderás la oportunidad de utilizarla en mediciones futuras.' : '¡Se perderá el análisis histórico!'
      }

    }
  }

  const hasMeasureCustomMessage2 = () => {

    if(props.question){

      switch (props.question.id_question_type) {
        case TYPE_QUESTION.qualitative:
          return (
            <></>
          )
        case TYPE_QUESTION.multiple_choice:
          return (
            <p style={{ textAlign: "center" }}>
              Perderás la oportunidad de utilizarla en mediciones futuras.
            </p>
          );
        default:
          return (
            <>
              <p style={{ textAlign: "center" }}>
                Esta pregunta ha sido utilizada en{" "}
                <strong>{props.configSurvey.measures_count}</strong> mediciones en
                el sistema. Al eliminarlo, se{" "}
                <span style={{ textDecoration: "underline" }}>
                  perderá la oportunidad de analizar su resultado histórico.
                </span>
              </p>
              <p style={{ textAlign: "center" }}>
                Recuerda que también es posible <strong>editarlo</strong>{" "}
                directamente en la plataforma, de tal forma que el histórico no se
                vea afectado.
              </p>
            </>
          )
      }
    }
  }

  return (
    <ModalCustom
      modalOpen={props.modalOpen}
      showFooter
      onOk={onOk}
      onCancel={onCancel}>
      {props.configSurvey.measures_count === 0 ? (
        <>
          <img src={alertSvg} className="alertIcon" />
          <span
            style={{
              fontWeight: 600,
              fontSize: 14,
              marginBottom: 15,
            }}>
            ¿Estás seguro de que deseas eliminar la pregunta?
          </span>
          <p>Esta acción no es reversible.</p>
        </>
      ) : (
        <>
          <img src={alertSvg} className="alertIcon" />
          <p
            style={{
              fontWeight: 600,
              fontSize: 14,
              marginTop: 16,
              marginBottom: 15,
              textAlign: "center",
            }}>
            ¿Estás seguro de que deseas eliminar la pregunta? <br />
            <span style={{ marginTop: 10 }}>
              {hasMeasureCustomMessage()}
            </span>
          </p>
         {hasMeasureCustomMessage2()}
        </>
      )}
    </ModalCustom>
  )
}

export default ModalDeleteQuestion
